import {
  Box,
  Grid,
  Snackbar,
  TextField,
  Alert,
  ThemeProvide,
  createTheme,
  ThemeProvider,
  Menu,
  Stack,
  Select,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  Paper,
  FormControl,
  Checkbox,
  TableHead,
  TableBody,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import Dialog from "@mui/material/Dialog";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import HelpIcon from "@mui/icons-material/Help";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import ReactQuill from "react-quill";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { RemoveRedEye, KeyboardArrowDown } from "@mui/icons-material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DatePicker from "../../../Components/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { useNavigate } from "react-router-dom";
import HeaderProposal from "./HeaderProposal";
import config from "../../../Data/AuthUser";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { clientInvoiceApis } from "../../../Data/axios";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Proposal() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const [award, setAward] = React.useState("");
  const [givenTo, setGivenTo] = React.useState("");
  const [date, setDate] = React.useState(null);
  const [awardError, setAwardError] = React.useState(false);
  const [givenToError, setGivenToError] = useState("");
  const [dateError, setDateError] = useState("");
  const [summary, setSummary] = useState("");
  const [photo, setPhoto] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [updateGivenTo, setUpdateGivenTo] = React.useState("");
  const [updateAward, setUpdateAward] = React.useState("");
  const [updateSummary, setUpdateSummary] = React.useState("");
  const [updatePhoto, setUpdatePhoto] = React.useState("");

  const [rows, setRows] = useState([
    {
      // description: "",
      quantity: "",
      unit: "1",
      unitPrice: "",
      tax: [],
      amount: "0.00",
    },
  ]);
  const [updateDate, setUpdateDate] = React.useState("");
  const [updateGivenToError, setUpdateGivenToError] = React.useState("");
  const [updateAwardError, setUpdateAwardError] = React.useState("");
  const [updateDateError, setUpdateDateError] = React.useState("");
  const [data, SetData] = useState([]);
  const [appreciationData, setAppreciationData] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [update, setUpdate] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const user_id = "RPTPLDRV1726551541";
  const handleClickOpen = () => {
    setOpen(true);
  };
  const addRow = () => {
    setRows([
      ...rows,
      {
        // description: "",
        quantity: "",
        unit: "1",
        unitPrice: "",
        tax: [],
        amount: "",
      },
    ]);
  };
  const removeRow = (index) => {
    const updatedRows = rows.filter((row, i) => i !== index); // Remove row at given index
    setRows(updatedRows);
  };
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const [selectedRow, setSelectedRow] = React.useState({
    keys: [],
    values: [],
    open: false,
  });
  const [optionsValue, setOptionsValue] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [discountValue, setDiscountValue] = useState("");
  const [discountType, setDiscountType] = useState("2");
  const taxOptions = [
    { id: 1, label: "GST: 10%", rate: 10 },
    { id: 2, label: "CGST: 18%", rate: 18 },
    { id: 3, label: "VAT: 5%", rate: 5 },
  ];
  const [descriptions, setDescriptions] = useState([]); // State to store descriptions for each row
  const [files, setFiles] = useState([]);
  const handleDescriptionChange = (index, value) => {
    console.log(`Row description ${index} changed to ${value}`);
    const newDescriptions = [...descriptions];
    newDescriptions[index] = value;
    setDescriptions(newDescriptions);
  };
  useEffect(() => {
    fetchClientDriver();
  }, [user_id]);
  const fetchClientDriver = async () => {
    try {
      const response = await clientInvoiceApis.clientDriverById(user_id);
      setOptionsValue(response.data);
      setOptionsValue([]);
    } catch (error) {
      console.error("Error fetching client driver data:", error);
    }
  };
  const [items, setItems] = useState([]); // State to store descriptions for each row

  const handleItemsChange = (index, value) => {
    console.log(`Row ${index} changed to ${value}`);
    const newItems = [...items];
    newItems[index] = value;
    setItems(newItems);
  };
  const handleFileChangeMain = (index, event) => {
    const newFiles = [...files];
    newFiles[index] = event.target.files[0];
    setFiles(newFiles);
  };

  // Function to update values in the table
  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    // Update amount when quantity, unitPrice, or tax changes
    if (field === "quantity" || field === "unitPrice" || field === "tax") {
      const quantity = parseFloat(updatedRows[index]?.quantity) || 0;
      const unitPrice = parseFloat(updatedRows[index]?.unitPrice) || 0;
      const selectedTaxes = updatedRows[index]?.tax?.map((taxId) => {
        return taxOptions.find((tax) => tax.id === taxId)?.rate || 0;
      });
      const tax = selectedTaxes.reduce(
        (acc, rate) => acc + (quantity * unitPrice * rate) / 100,
        0
      );
      const amount = quantity * unitPrice + tax;
      updatedRows[index].amount = amount.toFixed(2);
    }

    setRows(updatedRows);
  };

  const handleClickUpdate = () => {
    setUpdate(true);
  };
  const [anchorEl1, setAnchorEl1] = useState(null);

  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const handleUpdateClose = () => {
    setUpdate(false);
  };
  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  async function getData() {
    try {
      // let results = await fetch(
      //   "https://rptpl.roadpilot.co.in/public/api/getAllClient"
      // );
      // results = await results.json();
      // setAppreciationData(results);
    } catch (error) {
      // console.error("Error fetching data:", error);
    }
  }
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleViewMore = async () => {
    try {
      // const result = await fetch(
      //   `https://rptpl.roadpilot.co.in/public/api/GetKnowledagebaseById/${"1"}`,
      //   {
      //     method: "POST",
      //   }
      // );
      // const rowData = await result.json();
      // navigate(`/finance/proposal/${"1"}`, { state: rowData });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const columns = [
    {
      name: "user_id",
      label: "Proposal",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Proposal
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },
    {
      name: "company_email",
      label: "Deals",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Deals
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "company_name",
      label: "Contact Name",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Contact Name
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Total",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Total
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Date",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Date
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Valid Till",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Valid Till
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Status
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {value || " "}
            </div>
          );
        },
      },
    },

    {
      name: "id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "70px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <>
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns content to the left
                alignItems: "center",
                paddingRight: "20px", // Add padding for starting point
              }}
            >
              <div style={{ paddingRight: "20px" }}>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleViewMore(tableMeta.rowData)}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <RemoveRedEye /> View More
                    </div>
                  </MenuItem>
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleEdit()}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <EditNoteIcon /> Edit
                    </div>
                  </MenuItem>
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleDelete(value)}
                      style={{
                        display: "flex",
                        justifyContent: "space-center",
                        alignItems: "center",
                      }}
                    >
                      <DeleteForeverIcon /> Delete
                    </div>
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </>
        ),
      },
    },
  ];
  async function handleEdit(id) {
    const result = appreciationData.filter((item) => item.id === id);
    SetData(result[0]);

    handleClickUpdate();
  }
  // useEffect(() => {
  //   setUpdateGivenTo(data.givenTo);
  // }, [data.givenTo]);

  // useEffect(() => {
  //   setUpdateAward(data.award);
  // }, [data.award]);
  // useEffect(() => {
  //   setUpdateAwardError(data.awardError);
  // }, [data.awardError]);
  // useEffect(() => {
  //   setUpdateDate(data.date);
  // }, [data.date]);
  // useEffect(() => {
  //   setUpdatePhoto(data.photo);
  // }, [data.photo]);
  // useEffect(() => {
  //   setUpdateSummary(data.summary);
  // }, [data.summary]);
  // useEffect(() => {
  //   setUpdateGivenToError(data.givenToError);
  // }, [data.givenToError]);

  async function UpdateData(id) {
    const formData = new FormData();

    formData.append("givenTo", updateGivenTo);
    formData.append("date", updateDate);
    formData.append("dateError", updateDateError);
    formData.append("award", updateAward);
    formData.append("photo", updatePhoto);
    formData.append("summary", updateSummary);
    formData.append("givenToError", updateGivenToError);
    formData.append("awardError", updateAwardError);
    try {
      // let response = await fetch(
      //   `https://rptpl.roadpilot.co.in/public/api/updateTaxSettings/${data.id}`,
      //   {
      //     method: "POST",
      //     body: formData,
      //   }
      // );
      // if (!response.ok) {
      //   throw new Error("Failed to update data");
      // }
      // console.log(response.json(), "this is json response");
      // handleUpdateClose();
      // showAlert("  Updated successfully", "success");
    } catch (error) {
      console.error(error);
      showAlert("Failed to update business location", "error");
    }
  }

  async function handleDelete(id) {
    const response = await fetch(
      "https://rptpl.roadpilot.co.in/public/api/deleteTaxSettings/" + id,
      {
        method: "DELETE",
      }
    );
    console.log(response, "response");
    //const result = await response.json(); // Assigning to a new variable
    if (response.ok) {
      getData();
      showAlert("Tax Data Deleted Successfully!", "warning");
    } else {
      showAlert("Tax Data Deleted failed!", "error");
    }
  }

  // Save Lead Sourse
  const item = {
    award,
    givenTo,
    photo,
    summary,
    date,
  };
  async function SaveData() {
    try {
      const response = await fetch(
        `https://rptpl.roadpilot.co.in/public/api/addTaxSettings`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      );
      console.log(response);
      // Check if the response is okay

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      // Read response as text for debugging

      // Try parsing the response as JSON

      showAlert("Tax Data Added Successfully!", "success");
      getData();
      setOpen(false);
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert("Failed to add tax data", "error");
    }
  }
  // const handleFileChange = (e) => {
  //     const file = e.target.files[0];
  //     setFileName(file.name); // Update file name
  //     console.log(file.name); // Print file name to console
  // };

  // Event handler to update the date state and log the date to the console
  const handleDateChange = (newDate) => {
    setDate(newDate); // Update the date state
    console.log(newDate); // Log the new date to the console
  };

  const handleChange = (value) => {
    setSummary(value); // Update the state with the new value
    // console.log(value); // Print the value to the console
  };

  const handlePhoto = (e) => {
    const file = e.target.files[0];
    setPhoto(file.name);
    console.log(file.name); // You can also upload the file to a server if needed
  };

  const handleSave = () => {
    const list = { award, givenTo, date, summary, photo };
    console.log(list);
    if (award === "") {
      setAwardError(true);
    } else {
      const list = { award, givenTo, date, summary, photo };
      console.log(list);
      setAwardError(false); // Reset the error state
      handleClose(); // Close the dialog
    }
  };

  const options = {
    selectableRows: "none",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 25, 100],
    onChangeRowsPerPage: (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
    },
    tableBody: {
      style: {
        maxHeight: `${rowsPerPage * 50}px`,
        overflow: "auto",
        marginLeft: "5px",
        transform: "translateZ(0)",
        backfaceVisibility: "hidden",
        boxShadow: "none",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "center",
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <HeaderProposal />

      <Dialog
        fullWidth
        maxWidth="lg"
        open={update}
        onClose={handleUpdateClose}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            background: "#141b2d",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar
          sx={{
            position: "relative",
            backgroundColor: "#1d82f5",
          }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon fontSize="large" />
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1, fontSize: "20px" }}
              component="div"
            >
              Update Proposal
            </Typography>
          </Toolbar>
        </AppBar>
        <Box
          sx={{
            backgroundColor: "white",
          }}
        >
          <Typography
            sx={{
              p: 2,
              flex: 1,
              borderBottom: "1px solid gray",
              color: "black",
              fontSize: { xs: "16px", sm: "20px" },
            }}
            component="div"
          >
            Proposal Details
          </Typography>

          <Grid
            container
            spacing={2}
            sx={{
              padding: { xs: "10px", sm: "20px" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              sx={{ paddingRight: { xs: 0, sm: 2 } }}
            >
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Lead Contacts <span style={{ color: "red" }}>*</span>
                </Typography>
                <Select
                  value={award}
                  autoFocus
                  onChange={(e) => setAward(e.target.value)}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    border: "1px solid black",
                    boxSizing: "border-box",
                    "& .MuiOutlinedInput-root": {
                      borderColor: "black !important",
                      "&:hover fieldset": {
                        borderColor: "black !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black !important",
                      },
                    },
                    color: "black",
                  }}
                >
                  <MenuItem disabled value="">
                    <em>---</em>
                  </MenuItem>
                  <MenuItem value={"Gold"}>Gold</MenuItem>
                  <MenuItem value={"Silver"}>Silver</MenuItem>
                  <MenuItem value={"Bronze"}>Bronze</MenuItem>
                </Select>
                {awardError && (
                  <Typography variant="caption" style={{ color: "red" }}>
                    Please select an award
                  </Typography>
                )}
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              sm={6}
              sx={{ paddingRight: { xs: 0, sm: 2 } }}
            >
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Deal <span style={{ color: "red" }}>*</span>
                </Typography>
                <Select
                  value={givenTo}
                  autoFocus
                  onChange={(e) => setGivenTo(e.target.value)}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    border: "1px solid black",
                    boxSizing: "border-box",
                    "& .MuiOutlinedInput-root": {
                      borderColor: "black !important",
                      "&:hover fieldset": {
                        borderColor: "black !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black !important",
                      },
                    },
                    color: "black",
                  }}
                >
                  <MenuItem disabled value="">
                    <em>---</em>
                  </MenuItem>
                  <MenuItem value={"Andrew"}>Andrew</MenuItem>
                  <MenuItem value={"Bohr"}>Bohr</MenuItem>
                  <MenuItem value={"Ceaser"}>Ceaser</MenuItem>
                </Select>
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              sm={6}
              sx={{ paddingRight: { xs: 0, sm: 2 } }}
            >
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Valid Till
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={["DatePicker"]}
                    onChange={(e) => handleDateChange(e.target.value)}
                    sx={{ marginTop: "-10px" }}
                  >
                    <DatePicker
                      value={date}
                      onChange={handleDateChange}
                      sx={{
                        border: "1px solid black",
                        borderRadius: "5px",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          color: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        "& .MuiSvgIcon-root": {
                          color: "black",
                        },
                      }}
                    >
                      {/* TextField component now becomes a child of DatePicker */}
                      {(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          // Add any additional TextField props if needed
                        />
                      )}
                    </DatePicker>
                  </DemoContainer>
                </LocalizationProvider>
              </Stack>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            sx={{
              padding: { xs: "10px", sm: "20px" },
            }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              sx={{ paddingRight: { xs: 0, sm: 2 } }}
            >
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Currency
                </Typography>
                <Select
                  value={award}
                  autoFocus
                  onChange={(e) => setAward(e.target.value)}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    border: "1px solid black",
                    boxSizing: "border-box",
                    "& .MuiOutlinedInput-root": {
                      borderColor: "black !important",
                      "&:hover fieldset": {
                        borderColor: "black !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black !important",
                      },
                    },
                    color: "black",
                  }}
                >
                  <MenuItem value={""}>USD($)</MenuItem>
                  <MenuItem value={"Silver"}>IND(₹)</MenuItem>
                  <MenuItem value={"Bronze"}>EUR(€)</MenuItem>
                </Select>
              </Stack>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              sm={6}
              sx={{ paddingRight: { xs: 0, sm: 2 } }}
            >
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Calculate Tax
                </Typography>
                <Select
                  value={givenTo}
                  autoFocus
                  onChange={(e) => setGivenTo(e.target.value)}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    border: "1px solid black",
                    boxSizing: "border-box",
                    "& .MuiOutlinedInput-root": {
                      borderColor: "black !important",
                      "&:hover fieldset": {
                        borderColor: "black !important",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "black !important",
                      },
                    },
                    color: "black",
                  }}
                >
                  <MenuItem value={""}>After Discount</MenuItem>
                  <MenuItem value={"Bohr"}>Before Discount</MenuItem>
                </Select>
              </Stack>
            </Grid>
          </Grid>
          <Grid container sx={{ padding: "20px" }}>
            <Stack direction="column" sx={{ width: "100%" }}>
              <Typography variant="p" gutterBottom style={{ color: "black" }}>
                Description
              </Typography>
              {/* <CustomToolbar style={{ color: 'black' }} /> Render custom emoji toolbar */}
              <ReactQuill
                value={summary}
                onChange={handleChange}
                // modules={modules}
                // theme="snow"
                style={{
                  // border: '1px solid black',
                  // borderRadius: '4px',
                  //padding: '10px',
                  width: "100%",
                  boxSizing: "border-box",
                  color: "black",
                  borderBlockColor: "black",
                  // minHeight: '100px' // Set your desired minimum height
                }}
              />
              {/* <SuppressWarnings>
                                  <ReactQuill
                                    value={summary}
                                    onChange={handleChange}
                                    style={{
                                      width: '100%',
                                      boxSizing: 'border-box',
                                      color: 'black',
                                      borderBlockColor: 'black'
                                    }}
                                  />
                                </SuppressWarnings> */}
            </Stack>
          </Grid>
          <br></br>
          <br></br>
          <Grid
            container
            spacing={2}
            sx={{
              color: "#000",
              padding: "20px",
              marginLeft: "0px",
            }}
          >
            <TableContainer
              component={Paper}
              style={{ backgroundColor: "#f9f9f9" }}
            >
              <Table aria-label="finance table">
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="left"
                      style={{
                        fontWeight: "bold",
                        color: "#333",
                        width: "20%",
                      }}
                    >
                      Description
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        fontWeight: "bold",
                        color: "#333",
                        width: "20%",
                      }}
                    >
                      Quantity
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        fontWeight: "bold",
                        color: "#333",
                        width: "20%",
                      }}
                    >
                      Unit Price
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        fontWeight: "bold",
                        color: "#333",
                        width: "20%",
                      }}
                    >
                      Tax
                    </TableCell>
                    <TableCell
                      align="left"
                      style={{
                        fontWeight: "bold",
                        color: "#333",
                        width: "20%",
                      }}
                    >
                      Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows?.map((row, index) => (
                    <React.Fragment key={index}>
                      <TableRow style={{ backgroundColor: "#fff" }} key={index}>
                        <TableCell sx={{ borderTop: "1px solid #333" }}>
                          <Select
                            labelId="department-select-label"
                            id={`department-select-${index}`}
                            value={items[index] || ""}
                            onChange={(e) =>
                              handleItemsChange(index, e.target.value)
                            }
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 60 * 3 + 8,
                                },
                              },
                            }}
                            sx={{
                              border: "1px solid black",
                              boxSizing: "border-box",
                              "& .MuiOutlinedInput-root": {
                                borderColor: "black !important",
                                "&:hover fieldset": {
                                  borderColor: "black !important",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "black !important",
                                },
                              },
                              color: "black",
                              width: "100%",
                            }}
                            renderValue={(selected) => {
                              if (selected.length === 0) {
                                return (
                                  <span style={{ color: "gray" }}>
                                    Select Client's Drivers
                                  </span>
                                );
                              }
                              return selected;
                            }}
                          >
                            {optionsValue && optionsValue?.length === 0 ? (
                              <MenuItem disabled>No drivers available</MenuItem>
                            ) : (
                              optionsValue?.map((option) => {
                                const imageUrl = `${config.apiImageUrl}${option?.app_user?.image}`;
                                return (
                                  <MenuItem
                                    key={option?.corp_driver?.id}
                                    value={option?.app_user?.username}
                                    sx={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "start",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <img
                                        src={
                                          imageUrl || "/defaultDriverImage.png"
                                        } // Fallback to default image
                                        alt={
                                          option?.app_user?.username || "Driver"
                                        }
                                        style={{
                                          width: 30,
                                          height: 30,
                                          borderRadius: "50%",
                                          marginRight: 10,
                                        }}
                                      />
                                      {/* Driver Name and Info */}
                                      <span>
                                        {option?.app_user?.username || ""}
                                      </span>
                                    </Box>
                                    <div>
                                      {option?.corp_driver?.driver_id || ""}
                                    </div>
                                  </MenuItem>
                                );
                              })
                            )}
                          </Select>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{ borderTop: "1px solid #333" }}
                        >
                          <TextField
                            type="number"
                            value={row.quantity}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "quantity",
                                e.target.value
                              )
                            }
                            fullWidth
                            placeholder="1"
                            inputProps={{ style: { color: "black" } }}
                            sx={{
                              border: "1px solid black",
                              borderRadius: "5px",
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                borderColor: "black !important",
                                "&:hover fieldset": {
                                  borderColor: "black !important",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "black !important",
                                },
                              },
                              color: "black",
                            }}
                          />
                          <FormControl fullWidth sx={{ marginLeft: "150px" }}>
                            <Select
                              value={row.unit}
                              onChange={(e) =>
                                handleInputChange(index, "unit", e.target.value)
                              }
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              sx={{
                                border: "1px solid gray",
                                height: "30px",
                                width: "80px",
                                boxSizing: "border-box",
                                "& .MuiOutlinedInput-root": {
                                  borderColor: "black !important",
                                  "&:hover fieldset": {
                                    borderColor: "black !important",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "black !important",
                                  },
                                },
                                color: "black",
                              }}
                            >
                              <MenuItem value="1">Days</MenuItem>
                              <MenuItem value="2">Pcs</MenuItem>
                              <MenuItem value="3">Km</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{ borderTop: "1px solid #333" }}
                        >
                          <TextField
                            type="number"
                            value={row.unitPrice}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "unitPrice",
                                e.target.value
                              )
                            }
                            fullWidth
                            placeholder="0.00"
                            inputProps={{ style: { color: "black" } }}
                            sx={{
                              border: "1px solid black",
                              borderRadius: "5px",
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                borderColor: "black !important",
                                "&:hover fieldset": {
                                  borderColor: "black !important",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "black !important",
                                },
                              },
                              color: "black",
                            }}
                          />
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{ borderTop: "1px solid #333" }}
                        >
                          <FormControl fullWidth>
                            <Select
                              multiple
                              value={row.tax}
                              onChange={(e) =>
                                handleInputChange(index, "tax", e.target.value)
                              }
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                              sx={{
                                border: "1px solid black",
                                boxSizing: "border-box",
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                  borderColor: "black !important",
                                  "&:hover fieldset": {
                                    borderColor: "black !important",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "black !important",
                                  },
                                },
                                color: "black",
                              }}
                              renderValue={(selected) =>
                                selected.length === 0 ? (
                                  <span style={{ color: "gray" }}>
                                    Select Tax Option
                                  </span>
                                ) : (
                                  selected
                                    .map(
                                      (id) =>
                                        taxOptions.find(
                                          (option) => option.id === id
                                        )?.label
                                    )
                                    .join(", ")
                                )
                              }
                              style={{
                                backgroundColor: "#fff",
                                color: "#000",
                              }}
                            >
                              {taxOptions.map((taxOption) => (
                                <MenuItem
                                  key={taxOption.id}
                                  value={taxOption.id}
                                >
                                  <Checkbox
                                    checked={row.tax.indexOf(taxOption.id) > -1}
                                    sx={{
                                      color: "#fff",
                                      "&.Mui-checked": {
                                        color: "#fff",
                                      },
                                    }}
                                  />
                                  <ListItemText primary={taxOption.label} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{ borderTop: "1px solid #333" }}
                        >
                          <TextField
                            value={row.amount}
                            InputProps={{
                              readOnly: true,
                            }}
                            fullWidth
                            inputProps={{ style: { color: "black" } }}
                            sx={{
                              border: "1px solid black",
                              borderRadius: "5px",
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                borderColor: "black !important",
                                "&:hover fieldset": {
                                  borderColor: "black !important",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "black !important",
                                },
                              },
                              color: "black",
                            }}
                          />
                        </TableCell>
                        <TableCell
                          width="10%"
                          sx={{
                            padding: "10px",
                            borderTop: "1px solid #333",
                          }}
                        >
                          <IconButton onClick={() => removeRow(index)}>
                            <RemoveCircleOutlineIcon color="error" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow key={index}>
                        <TableCell colSpan={4} sx={{ borderBottom: "none" }}>
                          <TextField
                            multiline
                            value={descriptions[index] || ""} // Use the correct description for each row
                            rows={1}
                            placeholder="Enter Description"
                            onChange={(e) =>
                              handleDescriptionChange(index, e.target.value)
                            } // Update description for the row
                            fullWidth
                            variant="outlined"
                            inputProps={{ style: { color: "black" } }}
                            sx={{
                              border: "1px solid black",
                              borderRadius: "5px",
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                borderColor: "black !important",
                                "&:hover fieldset": {
                                  borderColor: "black !important",
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "black !important",
                                },
                              },
                              color: "black",
                            }}
                          />
                        </TableCell>
                        <TableCell align="right" sx={{ borderBottom: "none" }}>
                          <label
                            htmlFor={`file-upload-main-${index}`}
                            style={{
                              cursor: "pointer",
                              color: "black",
                              border: "1px solid black",
                              borderRadius: "4px",
                              padding: "10px",
                              width: "100%",
                              boxSizing: "border-box",
                              minHeight: "55px",
                              backgroundColor: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            Choose a File
                          </label>
                          <input
                            onChange={(e) => handleFileChangeMain(index, e)}
                            type="file"
                            id={`file-upload-main-${index}`}
                            style={{ display: "none" }}
                          />
                          {files[index] && (
                            <div style={{ color: "black" }}>
                              {files[index]?.name}{" "}
                            </div>
                          )}
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Box
            onClick={addRow}
            sx={{
              marginTop: "10px",
              // width: "150px",
              height: "60px",
              color: "#1d82f5",
              cursor: "pointer",
              fontWeight: "550",
              fontSize: "15px",
              display: "flex",
              paddingLeft: "30px",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <AddCircleOutlineIcon /> Add Item
          </Box>
          <Box
            sx={{
              display: "flex",
              paddingLeft: { lg: "4px", md: "4px", xs: "3px" },
              backgroundColor: "#f9f9f9",
              padding: "16px",
              borderRadius: "4px",
              marginTop: "10px",
              marginBottom: "15px",
            }}
          >
            <Table width="100%" sx={{ textAlign: "right", fontSize: 14 }}>
              <TableBody>
                <TableRow>
                  <TableCell
                    width="50%"
                    sx={{
                      border: 0,
                      display: {
                        lg: "table-cell",
                        md: "table-cell",
                        xs: "none",
                      },
                    }}
                  ></TableCell>
                  <TableCell width="50%" sx={{ padding: 0, border: 0 }}>
                    <Table width="100%">
                      <TableBody>
                        <TableRow>
                          <TableCell
                            sx={{
                              borderTop: " 0px",
                              color: "#000",
                              fontSize: "15px",
                              fontWeight: "550",
                            }}
                          >
                            Sub Total
                          </TableCell>
                          <TableCell
                            sx={{
                              borderTop: 0,
                              color: "#000",
                              fontSize: "15px",
                              textAlign: "right",
                              fontWeight: "550",
                            }}
                          >
                            Rs. {subtotal.toFixed(2)}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell
                            sx={{
                              color: "#000",
                              fontSize: "15px",
                              fontWeight: "550",
                              borderBottom: "none",
                            }}
                          >
                            Discount
                          </TableCell>
                          <TableCell
                            sx={{
                              padding: "10px",
                              color: "#000",
                              fontSize: "15px",
                              textAlign: "right",
                              fontWeight: "550",
                              borderBottom: "none",
                            }}
                          >
                            <Table width="100%">
                              <TableBody>
                                <TableRow
                                  sx={{
                                    display: "flex",
                                    justifyContent: "right",
                                    alignItems: "center",
                                  }}
                                >
                                  <TableCell
                                    width="100%"
                                    sx={{
                                      borderBottom: "none",
                                      marginLeft: "150px",
                                    }}
                                  >
                                    <TextField
                                      type="number"
                                      value={discountValue}
                                      onChange={(e) =>
                                        setDiscountValue(e.target.value)
                                      }
                                      fullWidth
                                      placeholder="0"
                                      variant="outlined"
                                      inputProps={{
                                        style: {
                                          color: "black",
                                          padding: "10px",
                                        },
                                      }}
                                      sx={{
                                        border: "1px solid black",
                                        borderRadius: "5px",
                                        textAlign: "right",
                                        // padding: "10px",
                                        width: "100px",
                                        "& .MuiOutlinedInput-root": {
                                          borderColor: "black !important",
                                          "&:hover fieldset": {
                                            borderColor: "black !important",
                                          },
                                          "&.Mui-focused fieldset": {
                                            borderColor: "black !important",
                                          },
                                        },
                                        color: "black",
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      borderBottom: "none",
                                      marginRight: "100px",
                                    }}
                                  >
                                    <Select
                                      value={discountType}
                                      onChange={(e) =>
                                        setDiscountType(e.target.value)
                                      }
                                      inputProps={{
                                        style: {
                                          color: "black",
                                          padding: "0px",
                                        },
                                      }}
                                      sx={{
                                        backgroundColor: "#fff",
                                        color: "#000",
                                        height: "40px",
                                        maxWidth: "100px",
                                        border: "1px solid gray",
                                      }}
                                    >
                                      <MenuItem value="1">%</MenuItem>
                                      <MenuItem value="2">Amount</MenuItem>
                                    </Select>
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      borderTop: 0,
                                      color: "#000",
                                      fontSize: "15px",
                                      fontWeight: "550",
                                      borderBottom: "none",
                                      display: "flex",
                                    }}
                                  >
                                    Rs.{discountValue}
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableCell>
                        </TableRow>
                        <TableRow
                          sx={{
                            backgroundColor: "#E0E0E0",
                            fontSize: 16,
                            fontWeight: 500,
                            color: "#000",
                          }}
                        >
                          <TableCell
                            sx={{
                              color: "#000",
                              fontSize: "15px",
                              fontWeight: "550",
                            }}
                          >
                            Total
                          </TableCell>
                          <TableCell
                            sx={{
                              color: "#000",
                              fontSize: "15px",
                              fontWeight: "550",
                              textAlign: "right",
                            }}
                          >
                            Rs. {total}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
          <Grid container sx={{ padding: "10px 0 20px 38px" }}>
            <Grid item xs={11} className="messageFooter">
              <Box>
                <Button
                  id="basic-button"
                  aria-controls={open1 ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open1 ? "true" : undefined}
                  onClick={handleClick1}
                  className="response"
                  endIcon={<KeyboardArrowDown />}
                  sx={{
                    width: "120%",
                    height: "100%",
                    color: "#fff",
                    bgcolor: "#1d82f5",
                    "&:hover": {
                      bgcolor: "orange",
                    },
                  }}
                >
                  Save
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl1}
                  open={open1}
                  onClose={handleClose1}
                  sx={{ zIndex: 3000 }}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem
                    value="closed"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <SaveOutlinedIcon fontSize="small" color="gray" /> &nbsp;
                    Save as Draft
                  </MenuItem>
                  <MenuItem
                    value="open"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {" "}
                    <SaveOutlinedIcon
                      fontSize="small"
                      sx={{ color: "gray" }}
                    />{" "}
                    &nbsp; Save
                  </MenuItem>
                  <MenuItem
                    value="pending"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {" "}
                    <SendOutlinedIcon
                      fontSize="small"
                      sx={{ color: "gray" }}
                    />{" "}
                    &nbsp; Save & Send
                  </MenuItem>
                </Menu>
              </Box>
              <Button
                className="cancel"
                onClick={handleClose}
                variant="outlined"
                sx={{ color: "gray", marginLeft: "10px" }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>

      <List style={{ background: "none" }}>
        <ListItemText style={{ background: "none" }}>
          <Stack direction="row" spacing={2} sx={{ marginBottom: "5px" }}>
            <Box
              onClick={handleClickOpen}
              sx={{
                backgroundColor: "#1d82f5",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                padding: "10px",
                marginLeft: "2px",
                height: "40px",
                width: "140px",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                borderRadius: "4px",
                fontSize: "15px",
                fontFamily: "sans-serif",
                cursor: "pointer",
                marginBottom: "5px",
              }}
            >
              <AddIcon />
              Add Proposal
            </Box>
          </Stack>
          <Dialog
            fullWidth
            maxWidth="lg"
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            PaperProps={{
              style: {
                position: "absolute",
                background: "#141b2d",
                top: "0",
                backgroundColor: "white",
                maxHeight: "95%",
                margin: "auto",
                overflowX: "hidden",
                zIndex: 1200,
              },
            }}
          >
            <AppBar
              sx={{
                position: "relative",
                backgroundColor: "#1d82f5",
              }}
            >
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={handleClose}
                  aria-label="close"
                >
                  <CloseIcon fontSize="large" />
                </IconButton>
                <Typography
                  sx={{ ml: 2, flex: 1, fontSize: "20px" }}
                  component="div"
                >
                  New Proposal
                </Typography>
              </Toolbar>
            </AppBar>
            <Box
              sx={{
                backgroundColor: "white",
              }}
            >
              <Typography
                sx={{
                  p: 2,
                  flex: 1,
                  borderBottom: "1px solid gray",
                  color: "black",
                  fontSize: { xs: "16px", sm: "20px" },
                }}
                component="div"
              >
                Proposal Details
              </Typography>

              <Grid
                container
                spacing={2}
                sx={{
                  padding: { xs: "10px", sm: "20px" },
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Lead Contacts <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Select
                      value={award}
                      autoFocus
                      onChange={(e) => setAward(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      <MenuItem value={"Gold"}>Gold</MenuItem>
                      <MenuItem value={"Silver"}>Silver</MenuItem>
                      <MenuItem value={"Bronze"}>Bronze</MenuItem>
                    </Select>
                    {awardError && (
                      <Typography variant="caption" style={{ color: "red" }}>
                        Please select an award
                      </Typography>
                    )}
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={6}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Deal <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Select
                      value={givenTo}
                      autoFocus
                      onChange={(e) => setGivenTo(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      <MenuItem value={"Andrew"}>Andrew</MenuItem>
                      <MenuItem value={"Bohr"}>Bohr</MenuItem>
                      <MenuItem value={"Ceaser"}>Ceaser</MenuItem>
                    </Select>
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={6}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Valid Till
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker"]}
                        onChange={(e) => handleDateChange(e.target.value)}
                        sx={{ marginTop: "-10px" }}
                      >
                        <DatePicker
                          value={date}
                          onChange={handleDateChange}
                          sx={{
                            border: "1px solid black",
                            borderRadius: "5px",
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black !important",
                              color: "black !important",
                              "&:hover fieldset": {
                                borderColor: "black !important",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black !important",
                              },
                            },
                            "& .MuiSvgIcon-root": {
                              color: "black",
                            },
                          }}
                        >
                          {/* TextField component now becomes a child of DatePicker */}
                          {(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              // Add any additional TextField props if needed
                            />
                          )}
                        </DatePicker>
                      </DemoContainer>
                    </LocalizationProvider>
                  </Stack>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                sx={{
                  padding: { xs: "10px", sm: "20px" },
                }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Currency
                    </Typography>
                    <Select
                      value={award}
                      autoFocus
                      onChange={(e) => setAward(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem value={""}>USD($)</MenuItem>
                      <MenuItem value={"Silver"}>IND(₹)</MenuItem>
                      <MenuItem value={"Bronze"}>EUR(€)</MenuItem>
                    </Select>
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={6}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Calculate Tax
                    </Typography>
                    <Select
                      value={givenTo}
                      autoFocus
                      onChange={(e) => setGivenTo(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem value={""}>After Discount</MenuItem>
                      <MenuItem value={"Bohr"}>Before Discount</MenuItem>
                    </Select>
                  </Stack>
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "20px" }}>
                <Stack direction="column" sx={{ width: "100%" }}>
                  <Typography
                    variant="p"
                    gutterBottom
                    style={{ color: "black" }}
                  >
                    Description
                  </Typography>
                  {/* <CustomToolbar style={{ color: 'black' }} /> Render custom emoji toolbar */}
                  <ReactQuill
                    value={summary}
                    onChange={handleChange}
                    // modules={modules}
                    // theme="snow"
                    style={{
                      // border: '1px solid black',
                      // borderRadius: '4px',
                      //padding: '10px',
                      width: "100%",
                      boxSizing: "border-box",
                      color: "black",
                      borderBlockColor: "black",
                      // minHeight: '100px' // Set your desired minimum height
                    }}
                  />
                  {/* <SuppressWarnings>
                                  <ReactQuill
                                    value={summary}
                                    onChange={handleChange}
                                    style={{
                                      width: '100%',
                                      boxSizing: 'border-box',
                                      color: 'black',
                                      borderBlockColor: 'black'
                                    }}
                                  />
                                </SuppressWarnings> */}
                </Stack>
              </Grid>
              <br></br>
              <br></br>
              <Grid
                container
                spacing={2}
                sx={{
                  color: "#000",
                  padding: "20px",
                  marginLeft: "0px",
                }}
              >
                <TableContainer
                  component={Paper}
                  style={{ backgroundColor: "#f9f9f9" }}
                >
                  <Table aria-label="finance table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="left"
                          style={{
                            fontWeight: "bold",
                            color: "#333",
                            width: "20%",
                          }}
                        >
                          Description
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            fontWeight: "bold",
                            color: "#333",
                            width: "20%",
                          }}
                        >
                          Quantity
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            fontWeight: "bold",
                            color: "#333",
                            width: "20%",
                          }}
                        >
                          Unit Price
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            fontWeight: "bold",
                            color: "#333",
                            width: "20%",
                          }}
                        >
                          Tax
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            fontWeight: "bold",
                            color: "#333",
                            width: "20%",
                          }}
                        >
                          Amount
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows?.map((row, index) => (
                        <React.Fragment key={index}>
                          <TableRow
                            style={{ backgroundColor: "#fff" }}
                            key={index}
                          >
                            <TableCell sx={{ borderTop: "1px solid #333" }}>
                              <Select
                                labelId="department-select-label"
                                id={`department-select-${index}`}
                                value={items[index] || ""}
                                onChange={(e) =>
                                  handleItemsChange(index, e.target.value)
                                }
                                displayEmpty
                                inputProps={{ "aria-label": "Without label" }}
                                MenuProps={{
                                  PaperProps: {
                                    style: {
                                      maxHeight: 60 * 3 + 8,
                                    },
                                  },
                                }}
                                sx={{
                                  border: "1px solid black",
                                  boxSizing: "border-box",
                                  "& .MuiOutlinedInput-root": {
                                    borderColor: "black !important",
                                    "&:hover fieldset": {
                                      borderColor: "black !important",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black !important",
                                    },
                                  },
                                  color: "black",
                                  width: "100%",
                                }}
                                renderValue={(selected) => {
                                  if (selected.length === 0) {
                                    return (
                                      <span style={{ color: "gray" }}>
                                        Select Client's Drivers
                                      </span>
                                    );
                                  }
                                  return selected;
                                }}
                              >
                                {optionsValue && optionsValue?.length === 0 ? (
                                  <MenuItem disabled>
                                    No drivers available
                                  </MenuItem>
                                ) : (
                                  optionsValue?.map((option) => {
                                    const imageUrl = `${config.apiImageUrl}${option?.app_user?.image}`;
                                    return (
                                      <MenuItem
                                        key={option?.corp_driver?.id}
                                        value={option?.app_user?.username}
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "start",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          <img
                                            src={
                                              imageUrl ||
                                              "/defaultDriverImage.png"
                                            } // Fallback to default image
                                            alt={
                                              option?.app_user?.username ||
                                              "Driver"
                                            }
                                            style={{
                                              width: 30,
                                              height: 30,
                                              borderRadius: "50%",
                                              marginRight: 10,
                                            }}
                                          />
                                          {/* Driver Name and Info */}
                                          <span>
                                            {option?.app_user?.username || ""}
                                          </span>
                                        </Box>
                                        <div>
                                          {option?.corp_driver?.driver_id || ""}
                                        </div>
                                      </MenuItem>
                                    );
                                  })
                                )}
                              </Select>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ borderTop: "1px solid #333" }}
                            >
                              <TextField
                                type="number"
                                value={row.quantity}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "quantity",
                                    e.target.value
                                  )
                                }
                                fullWidth
                                placeholder="1"
                                inputProps={{ style: { color: "black" } }}
                                sx={{
                                  border: "1px solid black",
                                  borderRadius: "5px",
                                  width: "100%",
                                  "& .MuiOutlinedInput-root": {
                                    borderColor: "black !important",
                                    "&:hover fieldset": {
                                      borderColor: "black !important",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black !important",
                                    },
                                  },
                                  color: "black",
                                }}
                              />
                              <FormControl
                                fullWidth
                                sx={{ marginLeft: "150px" }}
                              >
                                <Select
                                  value={row.unit}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "unit",
                                      e.target.value
                                    )
                                  }
                                  displayEmpty
                                  inputProps={{ "aria-label": "Without label" }}
                                  sx={{
                                    border: "1px solid gray",
                                    height: "30px",
                                    width: "80px",
                                    boxSizing: "border-box",
                                    "& .MuiOutlinedInput-root": {
                                      borderColor: "black !important",
                                      "&:hover fieldset": {
                                        borderColor: "black !important",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: "black !important",
                                      },
                                    },
                                    color: "black",
                                  }}
                                >
                                  <MenuItem value="1">Days</MenuItem>
                                  <MenuItem value="2">Pcs</MenuItem>
                                  <MenuItem value="3">Km</MenuItem>
                                </Select>
                              </FormControl>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ borderTop: "1px solid #333" }}
                            >
                              <TextField
                                type="number"
                                value={row.unitPrice}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "unitPrice",
                                    e.target.value
                                  )
                                }
                                fullWidth
                                placeholder="0.00"
                                inputProps={{ style: { color: "black" } }}
                                sx={{
                                  border: "1px solid black",
                                  borderRadius: "5px",
                                  width: "100%",
                                  "& .MuiOutlinedInput-root": {
                                    borderColor: "black !important",
                                    "&:hover fieldset": {
                                      borderColor: "black !important",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black !important",
                                    },
                                  },
                                  color: "black",
                                }}
                              />
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ borderTop: "1px solid #333" }}
                            >
                              <FormControl fullWidth>
                                <Select
                                  multiple
                                  value={row.tax}
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      "tax",
                                      e.target.value
                                    )
                                  }
                                  displayEmpty
                                  inputProps={{ "aria-label": "Without label" }}
                                  sx={{
                                    border: "1px solid black",
                                    boxSizing: "border-box",
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                      borderColor: "black !important",
                                      "&:hover fieldset": {
                                        borderColor: "black !important",
                                      },
                                      "&.Mui-focused fieldset": {
                                        borderColor: "black !important",
                                      },
                                    },
                                    color: "black",
                                  }}
                                  renderValue={(selected) =>
                                    selected.length === 0 ? (
                                      <span style={{ color: "gray" }}>
                                        Select Tax Option
                                      </span>
                                    ) : (
                                      selected
                                        .map(
                                          (id) =>
                                            taxOptions.find(
                                              (option) => option.id === id
                                            )?.label
                                        )
                                        .join(", ")
                                    )
                                  }
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                  }}
                                >
                                  {taxOptions.map((taxOption) => (
                                    <MenuItem
                                      key={taxOption.id}
                                      value={taxOption.id}
                                    >
                                      <Checkbox
                                        checked={
                                          row.tax.indexOf(taxOption.id) > -1
                                        }
                                        sx={{
                                          color: "#fff",
                                          "&.Mui-checked": {
                                            color: "#fff",
                                          },
                                        }}
                                      />
                                      <ListItemText primary={taxOption.label} />
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ borderTop: "1px solid #333" }}
                            >
                              <TextField
                                value={row.amount}
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                                inputProps={{ style: { color: "black" } }}
                                sx={{
                                  border: "1px solid black",
                                  borderRadius: "5px",
                                  width: "100%",
                                  "& .MuiOutlinedInput-root": {
                                    borderColor: "black !important",
                                    "&:hover fieldset": {
                                      borderColor: "black !important",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black !important",
                                    },
                                  },
                                  color: "black",
                                }}
                              />
                            </TableCell>
                            <TableCell
                              width="10%"
                              sx={{
                                padding: "10px",
                                borderTop: "1px solid #333",
                              }}
                            >
                              <IconButton onClick={() => removeRow(index)}>
                                <RemoveCircleOutlineIcon color="error" />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                          <TableRow key={index}>
                            <TableCell
                              colSpan={4}
                              sx={{ borderBottom: "none" }}
                            >
                              <TextField
                                multiline
                                value={descriptions[index] || ""} // Use the correct description for each row
                                rows={1}
                                placeholder="Enter Description"
                                onChange={(e) =>
                                  handleDescriptionChange(index, e.target.value)
                                } // Update description for the row
                                fullWidth
                                variant="outlined"
                                inputProps={{ style: { color: "black" } }}
                                sx={{
                                  border: "1px solid black",
                                  borderRadius: "5px",
                                  width: "100%",
                                  "& .MuiOutlinedInput-root": {
                                    borderColor: "black !important",
                                    "&:hover fieldset": {
                                      borderColor: "black !important",
                                    },
                                    "&.Mui-focused fieldset": {
                                      borderColor: "black !important",
                                    },
                                  },
                                  color: "black",
                                }}
                              />
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{ borderBottom: "none" }}
                            >
                              <label
                                htmlFor={`file-upload-main-${index}`}
                                style={{
                                  cursor: "pointer",
                                  color: "black",
                                  border: "1px solid black",
                                  borderRadius: "4px",
                                  padding: "10px",
                                  width: "100%",
                                  boxSizing: "border-box",
                                  minHeight: "55px",
                                  backgroundColor: "#fff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                Choose a File
                              </label>
                              <input
                                onChange={(e) => handleFileChangeMain(index, e)}
                                type="file"
                                id={`file-upload-main-${index}`}
                                style={{ display: "none" }}
                              />
                              {files[index] && (
                                <div style={{ color: "black" }}>
                                  {files[index]?.name}{" "}
                                </div>
                              )}
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
              <Box
                onClick={addRow}
                sx={{
                  marginTop: "10px",
                  // width: "150px",
                  height: "60px",
                  color: "#1d82f5",
                  cursor: "pointer",
                  fontWeight: "550",
                  fontSize: "15px",
                  display: "flex",
                  paddingLeft: "30px",
                  justifyContent: "left",
                  alignItems: "center",
                }}
              >
                <AddCircleOutlineIcon /> Add Item
              </Box>
              <Box
                sx={{
                  display: "flex",
                  paddingLeft: { lg: "4px", md: "4px", xs: "3px" },
                  backgroundColor: "#f9f9f9",
                  padding: "16px",
                  borderRadius: "4px",
                  marginTop: "10px",
                  marginBottom: "15px",
                }}
              >
                <Table width="100%" sx={{ textAlign: "right", fontSize: 14 }}>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        width="50%"
                        sx={{
                          border: 0,
                          display: {
                            lg: "table-cell",
                            md: "table-cell",
                            xs: "none",
                          },
                        }}
                      ></TableCell>
                      <TableCell width="50%" sx={{ padding: 0, border: 0 }}>
                        <Table width="100%">
                          <TableBody>
                            <TableRow>
                              <TableCell
                                sx={{
                                  borderTop: " 0px",
                                  color: "#000",
                                  fontSize: "15px",
                                  fontWeight: "550",
                                }}
                              >
                                Sub Total
                              </TableCell>
                              <TableCell
                                sx={{
                                  borderTop: 0,
                                  color: "#000",
                                  fontSize: "15px",
                                  textAlign: "right",
                                  fontWeight: "550",
                                }}
                              >
                                Rs. {subtotal.toFixed(2)}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell
                                sx={{
                                  color: "#000",
                                  fontSize: "15px",
                                  fontWeight: "550",
                                  borderBottom: "none",
                                }}
                              >
                                Discount
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "10px",
                                  color: "#000",
                                  fontSize: "15px",
                                  textAlign: "right",
                                  fontWeight: "550",
                                  borderBottom: "none",
                                }}
                              >
                                <Table width="100%">
                                  <TableBody>
                                    <TableRow
                                      sx={{
                                        display: "flex",
                                        justifyContent: "right",
                                        alignItems: "center",
                                      }}
                                    >
                                      <TableCell
                                        width="100%"
                                        sx={{
                                          borderBottom: "none",
                                          marginLeft: "150px",
                                        }}
                                      >
                                        <TextField
                                          type="number"
                                          value={discountValue}
                                          onChange={(e) =>
                                            setDiscountValue(e.target.value)
                                          }
                                          fullWidth
                                          placeholder="0"
                                          variant="outlined"
                                          inputProps={{
                                            style: {
                                              color: "black",
                                              padding: "10px",
                                            },
                                          }}
                                          sx={{
                                            border: "1px solid black",
                                            borderRadius: "5px",
                                            textAlign: "right",
                                            // padding: "10px",
                                            width: "100px",
                                            "& .MuiOutlinedInput-root": {
                                              borderColor: "black !important",
                                              "&:hover fieldset": {
                                                borderColor: "black !important",
                                              },
                                              "&.Mui-focused fieldset": {
                                                borderColor: "black !important",
                                              },
                                            },
                                            color: "black",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          borderBottom: "none",
                                          marginRight: "100px",
                                        }}
                                      >
                                        <Select
                                          value={discountType}
                                          onChange={(e) =>
                                            setDiscountType(e.target.value)
                                          }
                                          inputProps={{
                                            style: {
                                              color: "black",
                                              padding: "0px",
                                            },
                                          }}
                                          sx={{
                                            backgroundColor: "#fff",
                                            color: "#000",
                                            height: "40px",
                                            maxWidth: "100px",
                                            border: "1px solid gray",
                                          }}
                                        >
                                          <MenuItem value="1">%</MenuItem>
                                          <MenuItem value="2">Amount</MenuItem>
                                        </Select>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          borderTop: 0,
                                          color: "#000",
                                          fontSize: "15px",
                                          fontWeight: "550",
                                          borderBottom: "none",
                                          display: "flex",
                                        }}
                                      >
                                        Rs.{discountValue}
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableCell>
                            </TableRow>
                            <TableRow
                              sx={{
                                backgroundColor: "#E0E0E0",
                                fontSize: 16,
                                fontWeight: 500,
                                color: "#000",
                              }}
                            >
                              <TableCell
                                sx={{
                                  color: "#000",
                                  fontSize: "15px",
                                  fontWeight: "550",
                                }}
                              >
                                Total
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#000",
                                  fontSize: "15px",
                                  fontWeight: "550",
                                  textAlign: "right",
                                }}
                              >
                                Rs. {total}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
              <Grid container sx={{ padding: "10px 0 20px 38px" }}>
                <Grid item xs={11} className="messageFooter">
                  <Box>
                    <Button
                      id="basic-button"
                      aria-controls={open1 ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open1 ? "true" : undefined}
                      onClick={handleClick1}
                      className="response"
                      endIcon={<KeyboardArrowDown />}
                      sx={{
                        width: "120%",
                        height: "100%",
                        color: "#fff",
                        bgcolor: "#1d82f5",
                        "&:hover": {
                          bgcolor: "orange",
                        },
                      }}
                    >
                      Save
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl1}
                      open={open1}
                      onClose={handleClose1}
                      sx={{ zIndex: 3000 }}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem
                        value="closed"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <SaveOutlinedIcon fontSize="small" color="gray" />{" "}
                        &nbsp; Save as Draft
                      </MenuItem>
                      <MenuItem
                        value="open"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <SaveOutlinedIcon
                          fontSize="small"
                          sx={{ color: "gray" }}
                        />{" "}
                        &nbsp; Save
                      </MenuItem>
                      <MenuItem
                        value="pending"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <SendOutlinedIcon
                          fontSize="small"
                          sx={{ color: "gray" }}
                        />{" "}
                        &nbsp; Save & Send
                      </MenuItem>
                    </Menu>
                  </Box>
                  <Button
                    className="cancel"
                    onClick={handleClose}
                    variant="outlined"
                    sx={{ color: "gray", marginLeft: "10px" }}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Dialog>
        </ListItemText>
        <Divider />
        <ListItemText style={{ background: "white", margin: 0, width: "100%" }}>
          <ThemeProvider theme={getTheme()}>
            <MUIDataTable
              title={
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    color: "#333",
                  }}
                >
                  Proposal Lists
                </span>
              }
              data={appreciationData}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default Proposal;
